/**
 * Flattens Notion column layouts into a single block stream, in document
 * order. The event modal lays the poster out in its own split view, so the
 * Notion-side two-column arrangement (column_list > column > blocks) is
 * presentation we deliberately drop — rendering columns side-by-side inside
 * the ~550px content pane would be cramped and would duplicate the poster.
 * Generic so it accepts both the shared NotionBlock and the view-local one.
 */
export const flattenNotionColumns = <T extends { type: string; children?: T[] }>(
    blocks: T[],
): T[] =>
    blocks.flatMap((block) =>
        block.type === 'column_list' || block.type === 'column'
            ? flattenNotionColumns(block.children ?? [])
            : [block],
    )

/**
 * Notion's API returns links to other Notion pages (page mentions, "link to
 * page") as root-relative hrefs like `/25c0e…`, which would otherwise resolve
 * against this app's own origin. External links come through absolute and are
 * returned as-is.
 */
export const resolveNotionHref = (href: string): string =>
    href.startsWith('/') ? `https://www.notion.so${href}` : href
